export class ServiceTypePermissionModel {
    id: number;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/service-type-permission.model.ts